import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-students-dialog',
  templateUrl: './save-students-dialog.component.html',
  styleUrls: ['./save-students-dialog.component.scss']
})
export class SaveStudentsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SaveStudentsDialogComponent>) { }

  ngOnInit(): void {
  }

}
